import { FC, useMemo } from 'react'
import { UseFormRegister, UseFormGetValues, FieldErrors } from 'react-hook-form'
import { useTranslation } from 'next-i18next'
import { AddProductsToCart } from '../WishlistToolbar/AddProductsToCart'
import { getUidForConfigProducts } from '@corratech/pylot-wishlist/src/utils/getUidForConfigProducts'
import {
    Maybe,
    Wishlist,
    ConfigurableWishlistItem
} from '@pylot-data/pylotschema'
import s from '@pagestyles/Wishlist.module.scss'

//TODO: fix type any for complex form fields
export type Props = {
    wishlist: Wishlist
    item: Maybe<ConfigurableWishlistItem>
    register: UseFormRegister<any>
    index: number
    getValues: UseFormGetValues<any>
    errors: FieldErrors<any>
}

export const WishlistDetails: FC<Props> = ({
    wishlist,
    item,
    register,
    index,
    getValues,
    errors
}) => {
    const { t } = useTranslation(['wishlist'])
    const values = getUidForConfigProducts({
        product: item?.product,
        options: item?.bundle_options
    })

    const configOptionInputFields = useMemo(() => {
        if (values.length) {
            return (
                <div className="config-options">
                    {values?.map((value, key) => (
                        <input
                            key={key}
                            type="hidden"
                            defaultValue={value}
                            {...register(`${index}.selected_options.${key}`)}
                        />
                    ))}
                </div>
            )
        }
    }, [values])

    return (
        <div className={s['wishlist-details-container']}>
            <input
                type="hidden"
                defaultValue={String(item!.id)}
                {...register(`${index}.wishlist_item_id`)}
            />
            <div className="form-group">
                <label className="heading">
                    {t('wishlist|Description')}
                    <input
                        defaultValue={String(item!.description || '')}
                        {...register(`${index}.description`)}
                        type="text"
                        className="form-input"
                    />
                </label>
            </div>
            <div className="form-group">
                <label className="heading">
                    {t('wishlist|Qty')}
                    <span className="asterisk">*</span>
                </label>
                <div className={s['wishlist-add-cart']}>
                    <label>
                        <input
                            defaultValue={item!.quantity || 1}
                            {...register(`${index}.quantity`, {
                                required: 'This is a required field',
                                valueAsNumber: true,
                                validate: (value) =>
                                    !isNaN(Number(value)) ||
                                    'Please enter a valid number'
                            })}
                            type="text"
                            className={s['wishlist-qty']}
                        />
                    </label>
                    <AddProductsToCart
                        isValid={!errors[index]?.quantity}
                        wishlist={wishlist}
                        getValues={getValues}
                        buttonLabel={t('wishlist|Add to cart')}
                        index={index}
                        item={{
                            cartItems: [
                                {
                                    sku: item!.product?.sku!,
                                    selected_options: values,
                                    quantity: Number(item!.quantity)
                                }
                            ],
                            removeItems: [
                                {
                                    id: item!.id,
                                    productId: String(item?.product?.id)
                                }
                            ]
                        }}
                    />
                </div>
                {errors[index]?.quantity && (
                    <span className="error">
                        {t(errors[index]?.quantity?.message)}
                    </span>
                )}
            </div>
            {configOptionInputFields}
        </div>
    )
}
